import { render, staticRenderFns } from "./OperativeNotesForm.vue?vue&type=template&id=ece8c17e&scoped=true"
import script from "./OperativeNotesForm.vue?vue&type=script&lang=js"
export * from "./OperativeNotesForm.vue?vue&type=script&lang=js"
import style0 from "./OperativeNotesForm.vue?vue&type=style&index=0&id=ece8c17e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece8c17e",
  null
  
)

export default component.exports